import { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound, CreditCard, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function Settings() {
  const [form, setForm] = useState({ identifier: "", password: "", stripe_secret_key: "" });
  const [info, setInfo] = useState({ identifier: "", stripe_key_set: false });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => { setInfo(r.data); setForm((f) => ({ ...f, identifier: r.data.identifier })); }).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {};
      if (form.identifier && form.identifier !== info.identifier) payload.identifier = form.identifier;
      if (form.password) payload.password = form.password;
      if (form.stripe_secret_key) payload.stripe_secret_key = form.stripe_secret_key;
      await api.put("/admin/settings", payload);
      toast.success("Paramètres enregistrés");
      setForm((f) => ({ ...f, password: "", stripe_secret_key: "" }));
      const r = await api.get("/admin/settings");
      setInfo(r.data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Erreur");
    }
    setSaving(false);
  };

  return (
    <div className="max-w-2xl space-y-6" data-testid="settings-page">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold-400">Administration</p>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight sm:text-4xl">Paramètres</h1>
      </div>

      <form onSubmit={save} className="space-y-6">
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="mb-4 flex items-center gap-2"><KeyRound className="h-4 w-4 text-gold-400" /><h3 className="font-display font-semibold">Identifiants de connexion</h3></div>
          <div className="space-y-4">
            <div>
              <Label htmlFor="s-id">Identifiant</Label>
              <Input id="s-id" data-testid="settings-identifier" value={form.identifier} onChange={(e) => setForm({ ...form, identifier: e.target.value })} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="s-pw">Nouveau mot de passe</Label>
              <Input id="s-pw" data-testid="settings-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Laisser vide pour ne pas changer" className="mt-1.5" />
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="mb-1 flex items-center gap-2"><CreditCard className="h-4 w-4 text-gold-400" /><h3 className="font-display font-semibold">Clé Stripe secrète</h3></div>
          <p className="mb-4 flex items-center gap-1.5 text-xs text-muted-foreground"><ShieldCheck className="h-3.5 w-3.5" /> {info.stripe_key_set ? "Une clé personnalisée est configurée." : "Clé sandbox de test active par défaut."}</p>
          <Input data-testid="settings-stripe-key" type="password" value={form.stripe_secret_key} onChange={(e) => setForm({ ...form, stripe_secret_key: e.target.value })} placeholder="sk_live_… (optionnel)" />
        </div>

        <Button type="submit" disabled={saving} data-testid="settings-save" className="rounded-full bg-gold-500 text-black hover:bg-gold-400">
          {saving ? "Enregistrement…" : "Enregistrer"}
        </Button>
      </form>
    </div>
  );
}
